module.exports = __webpack_public_path__ + "assets/img/neck-bg.8241b17e.png";